module.exports = __webpack_public_path__ + "static/media/FolderYellowLight.e367fc0d.svg";